import { SanityProductCategory } from '@gelato-api-ui/core/sanity/sanity-product-category';
import { homeCategoryId } from '@gelato-api-ui/core/product-catalogue/product-search-categories';

export function isHomeCategory(category: SanityProductCategory): boolean {
  return !category || category.productModel === homeCategoryId;
}
